import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAlbumCustomPrintCartItem } from '../redux/helpers';
import {
  cartItemUpdate,
  toggleAlbumCustomPrintCartItem,
} from '../redux/checkoutActions';
import { CUSTOM_PRINT_TYPE } from '../../../constants/pro-custom-prints';

const useAccountCardCartCheckout = () => {
  const [accountCard, setAccountCard] = useState(null);
  const [globalAccountCard, setGlobalAccountCard] = useState(null);
  const dispatch = useDispatch();
  // Using accountCard.id has a few advantages, specifically:
  // 1. Find the card with a reliable id (i.e the card's id)
  // 2. Have multiple cards with the same albumCustomPrint but different overall designs (photos, etc)
  // 3. Allow us to go to other places and back to edit if desired, updating the actual card without issues
  const cartItem = useSelector(({ checkout }) =>
    getAlbumCustomPrintCartItem(checkout.cart, {
      albumCustomPrintId: globalAccountCard?.id,
      accountCardId: accountCard?.id,
    }),
  );

  useEffect(() => {
    if (
      cartItem &&
      accountCard &&
      globalAccountCard.id === cartItem.albumCustomPrint.id
    ) {
      dispatch(
        cartItemUpdate(cartItem.id, {
          ...cartItem,
          configuration: {
            accountCard,
          },
        }),
      );
    }
  }, [accountCard, globalAccountCard]);

  const onAddToCart = ({
    accountCard: addedCard,
    globalAccountCard: addedGlobalCard,
    pricing,
  }) => {
    if (!accountCard) {
      setAccountCard(addedCard);
    }
    if (!globalAccountCard) {
      setGlobalAccountCard(addedGlobalCard);
    }
    dispatch(
      toggleAlbumCustomPrintCartItem({
        albumCustomPrint: {
          id: addedGlobalCard?.id,
          price: pricing?.total_price,
          custom_print: {
            name: 'Waldogram',
            type: CUSTOM_PRINT_TYPE.WALDOGRAM,
          },
        },
        identity: {},
        subscribed: false,
        shipping: true,
        configuration: {
          accountCard: addedCard,
        },
      }),
    );
  };

  return {
    onAddToCart,
    setAccountCard,
    setGlobalAccountCard,
    hasCartItems: !!cartItem,
  };
};

export default useAccountCardCartCheckout;
